<template>
  <div v-if="preOrderBackerStage === 'grace-period' || preOrderBackerStage === 'shutoff'">
    <site-link
      :to="{ name: 'plans' }"
      class="button accent block margin-top-xl margin-bottom-0"
    >
      <font-awesome-icon
        :icon="$v7.regular.faRocketLaunch"
        class="margin-right-sm"
        size="lg"
      />
      Start a Subscription
    </site-link>
  </div>

  <div v-else-if="autoRenew && $dt.isBraintree">
    <button
      class="button accent block margin-top-xl"
      @click="$emit('setup-auto-renew')"
    >
      Set Up Auto-Renew!
    </button>
    <p>and don't worry about losing access to services and Pro features</p>
  </div>

  <div v-else-if="canReactivate">
    <site-link
      :to="{ name: 'plans' }"
      class="button warning block margin-top-xl margin-bottom-0"
    >
      Pick a Plan + Reactivate!
    </site-link>
  </div>
</template>

<script>
  export default {
    name: 'PlanAction',

    props: {
      determinations: {
        type: Object,
        required: true
      }
    },

    computed: {
      preOrderBackerStage() {
        return this.determinations.preOrderBackerStage
      },

      autoRenew() {
        const { withinRenewalGracePeriod, cancelAtPeriodEnd } = this.determinations

        return withinRenewalGracePeriod && cancelAtPeriodEnd
      },

      canReactivate() {
        const { ended } = this.determinations

        return ended
      }
    }
  }
</script>
